import { register } from '!/repository'
import { $t } from './main'

export * from './helpers'
export * from './main'

// register special store for translations within skins
register($t, '~')
